module.exports = __webpack_public_path__ + "img/cp-ipsecVpn.74a52375.jpg";